import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Cloudflare image resize helper for Auxo CDN assets
 * Rule 9: insert /cdn-cgi/image/<options>/ between origin and path
 * Cloudflare fit options: scale-down, contain, cover, crop, pad (no "inside")
 */
export function getOptimizedImageUrl(url, { width = 800, quality = 80, fit } = {}) {
  if (!url || typeof url !== "string") return "";
  if (!url.includes("assets.auxodev.dk") || url.includes("/cdn-cgi/image/")) {
    return url;
  }
  const parts = url.split("assets.auxodev.dk/");
  if (parts.length < 2) return url;
  const fitParam = fit ? `,fit=${fit}` : "";
  return `https://assets.auxodev.dk/cdn-cgi/image/width=${width},quality=${quality},format=auto${fitParam}/${parts[1]}`;
}
